import { ForwardedRef } from 'react'
import styled from 'styled-components'

import { Typography } from 'components/Typography/Typography'

export const StyledInput = styled.input<{ ref?: ForwardedRef<HTMLElement> }>`
  box-sizing: border-box;
  width: 100%;
  font-family: ${({ theme }) => theme.typography.family.Poppins} !important;
  text-align: right;
  background-color: transparent;
  border: none;
  color: ${p => p.theme.colors.text.primary};
  font-size: ${p => p.theme.typography.size.Label1}px;
  font-weight: 700;
  // padding: 6px;
  // &:disabled {
  //   cursor: not-allowed;
  // }

  @media screen and (max-width: ${p => p.theme.breakpoints.md}px) {
    font-size: ${p => p.theme.typography.size.Caption1}px;
  }
`
export const EstimatedValue = styled(Typography)`
  text-align: right;
  font-size: ${p => p.theme.typography.size.Caption1}px;
  margin-top: 8px;
  @media screen and (max-width: ${p => p.theme.breakpoints.md}px) {
    margin-top: 12px;
  }
`
